import React from "react";
import "./Portrait.scss";

const Portrait = () => {
  return <div className="Portrait"></div>;
};

export default Portrait;
